module.exports = __webpack_public_path__ + "media/images/menu-1-6f476dcf4d91bfe256f87c5531220707.jpg";